import { EMail } from '@/model/EMail'
import { ERROR_CODES } from '@/model/ERROR_CODES'

const EMAIL_PATTERN =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

function validateEmail(s: string): EMail {
  // TODO unit test it !!!
  const email: EMail = {
    value: s,
    errorCode: undefined,
    valid: false,
    length: s.length > 1,
    pattern: EMAIL_PATTERN.test(s),
  }
  email.valid = email.length && email.pattern
  email.errorCode = email.valid ? undefined : ERROR_CODES.mailInvalid
  return email
}

/**
 * maybe not needed anymore - the promise method is already in the component
 * @param email
 */
function evaluateEmail(email: EMail): Promise<EMail> {
  return new Promise((res) => {
    res(validateEmail(email.value))
  })
}

export { validateEmail, evaluateEmail }
